import React from 'react';

const statusBadge = status => {
  if (status === 'Active') return 'badge-success';
  if (status === 'Expired') return 'badge-danger';
  if (status === 'Cancelled') return 'badge-warning';
  return 'badge-info';
};

function ViewSubscriptionModal({ subscription: s, onClose }) {
  return (
    <div style={{
      position: 'fixed', inset: 0, background: 'rgba(0,0,0,0.7)',
      display: 'flex', alignItems: 'center', justifyContent: 'center',
      zIndex: 9999, padding: 16,
    }}>
      <div className="card animate-in" style={{ width: '100%', maxWidth: 480, maxHeight: '90vh', overflowY: 'auto' }}>
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 24 }}>
          <h2 className="font-heading" style={{ fontSize: 20 }}>Subscription Details</h2>
          <button onClick={onClose} style={{ background: 'none', border: 'none', color: 'var(--text-muted)', cursor: 'pointer', fontSize: 20 }}>✕</button>
        </div>

        {/* Avatar + name */}
        <div style={{ display: 'flex', alignItems: 'center', gap: 16, marginBottom: 24 }}>
          <div style={{
            width: 56, height: 56, borderRadius: '50%',
            background: 'var(--accent-gradient)',
            display: 'flex', alignItems: 'center', justifyContent: 'center',
            fontFamily: 'JetBrains Mono, monospace', fontWeight: 700, fontSize: 22, color: '#fff',
          }}>{s.name[0]}</div>
          <div>
            <div className="font-heading" style={{ fontSize: 18 }}>{s.name}</div>
            <div style={{ color: 'var(--text-muted)', fontSize: 12 }}>{s.id}</div>
          </div>
        </div>

        {[
          { label: 'Email',         value: s.email },
          { label: 'Plan',          value: s.plan, badge: 'badge-info' },
          { label: 'Billing',       value: s.billing },
          { label: 'Amount',        value: s.amount },
          { label: 'Start Date',    value: s.start },
          { label: 'Expiry Date',   value: s.expiry },
          { label: 'Status',        value: s.status, badge: statusBadge(s.status) },
        ].map(row => (
          <div key={row.label} style={{
            display: 'flex', justifyContent: 'space-between', alignItems: 'center',
            padding: '11px 0', borderBottom: '1px solid var(--border)',
          }}>
            <span style={{ fontSize: 11, color: 'var(--text-muted)', textTransform: 'uppercase', letterSpacing: 1, fontWeight: 600 }}>{row.label}</span>
            {row.badge
              ? <span className={`badge ${row.badge}`}>{row.value}</span>
              : <span style={{ color: 'var(--text-primary)', fontWeight: 500 }}>{row.value}</span>
            }
          </div>
        ))}

        <div style={{ display: 'flex', justifyContent: 'flex-end', marginTop: 20 }}>
          <button className="btn-secondary" onClick={onClose}>Close</button>
        </div>
      </div>
    </div>
  );
}

export default ViewSubscriptionModal;